<div class="likes-dialog">
  <div class="dialog-header">
    <div class="dialog-title">
      <mat-icon>favorite</mat-icon>
      <h2>
        {{
          (data.totalLikes === 1 ? 'translations.comments.likes.single' : 'translations.comments.likes.multiple')
            | transloco: { count: data.totalLikes }
        }}
      </h2>
    </div>
    <button
      mat-icon-button
      class="close-btn"
      (click)="closeDialog()"
      (keydown.escape)="closeDialog()"
      [attr.aria-label]="'translations.global.ariaLabels.close' | transloco"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="liked-users-list">
    <div
      class="liked-user-item"
      *ngFor="let user of data.likedBy; trackBy: trackByUserId"
      (click)="goToUserProfile(user.userId)"
      (keydown.enter)="goToUserProfile(user.userId)"
      tabindex="0"
      role="button"
      [attr.aria-label]="'translations.comments.likes.goToProfile' | transloco: { name: user.userName }"
    >
      <div class="user-avatar">
        <img [src]="user.userAvatarUrl || 'assets/icons/default-avatar.png'" [alt]="user.userName" class="avatar-image" />
      </div>

      <div class="user-info">
        <div class="user-name">{{ user.userName }}</div>
        <div class="liked-time">{{ user.likedAt | folioCardTimeAgo }}</div>
      </div>

      <mat-icon class="like-icon">favorite</mat-icon>
    </div>
  </div>
</div>
